module.exports = __webpack_public_path__ + "static/media/warning-modal.74f95594.svg";